export default {
  getAllMapHosts: state => state.mapHosts,
  getCurrentMapHost: state => state.currentMapHost,
  getCurrentMapHostObj: state => state.currentMapHostObj
}
